@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faLayerGroup"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'FILE_GROUPS.TITLE' | translate }}</h3>
          <p>{{ 'FILE_GROUPS.SUBTITLE' | translate }}</p>
        </div>
      </div>
      <button class="close-btn" type="button" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">

      <div class="groups-section">
        <div class="section-header">
          <span class="section-title">{{ 'FILE_GROUPS.GROUPS_LABEL' | translate }}</span>
          @if (!showNewGroupForm) {
          <button type="button" class="new-group-btn" (click)="openNewGroupForm()">
            <fa-icon [icon]="faPlus"></fa-icon>
            <span>{{ 'FILE_GROUPS.NEW_GROUP' | translate }}</span>
          </button>
          }
        </div>

        @if (showNewGroupForm) {
        <div class="group-form">
          <input type="text" class="group-name-input" [(ngModel)]="newGroupName"
            [placeholder]="'FILE_GROUPS.NAME_PLACEHOLDER' | translate" maxlength="50" (keyup.enter)="createGroup()" />
          <div class="color-palette">
            @for (color of predefinedColors; track color.bg_color) {
            <div class="color-item" [style.background-color]="color.bg_color" [title]="color.name"
              [class.selected]="newGroupColor?.bg_color === color.bg_color" (click)="newGroupColor = color"></div>
            }
          </div>
          <div class="form-actions">
            <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="cancelNewGroupForm()">
            </app-button>
            <app-button [text]="'BUTTON.SAVE' | translate" variant="primary" [icon]="faCheck"
              [disabled]="!newGroupName.trim()" (clicked)="createGroup()">
            </app-button>
          </div>
        </div>
        }

        @if (!isLoading && !groups.length && !showNewGroupForm) {
        <p class="empty-hint">{{ 'FILE_GROUPS.EMPTY_HINT' | translate }}</p>
        }

        <div class="groups-list">
          @for (group of groups; track group.id) {
          @if (editingGroupId === group.id) {
          <div class="group-form inline">
            <input type="text" class="group-name-input" [(ngModel)]="editGroupName" maxlength="50"
              (keyup.enter)="saveEditGroup(group)" />
            <div class="color-palette">
              @for (color of predefinedColors; track color.bg_color) {
              <div class="color-item" [style.background-color]="color.bg_color" [title]="color.name"
                [class.selected]="editGroupColor?.bg_color === color.bg_color" (click)="editGroupColor = color"></div>
              }
            </div>
            <div class="form-actions">
              <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="cancelEditGroup()">
              </app-button>
              <app-button [text]="'BUTTON.SAVE' | translate" variant="primary" [icon]="faCheck"
                [disabled]="!editGroupName.trim()" (clicked)="saveEditGroup(group)">
              </app-button>
            </div>
          </div>
          } @else {
          <div class="group-chip" [style.background-color]="group.bg_color" [style.color]="group.text_color">
            <span class="group-chip-name">{{ group.name }}</span>
            <span class="group-chip-count">{{ 'FILE_GROUPS.FILE_COUNT' | translate: { count: (group.archive_ids || []).length } }}</span>
            <button type="button" class="chip-icon-btn" [title]="'BUTTON.EDIT' | translate"
              (click)="startEditGroup(group)">
              <fa-icon [icon]="faPen"></fa-icon>
            </button>
            <button type="button" class="chip-icon-btn" [title]="'BUTTON.DELETE' | translate"
              (click)="requestDeleteGroup(group)">
              <fa-icon [icon]="faTrash"></fa-icon>
            </button>
          </div>
          }
          }
        </div>
      </div>

      @if (groups.length > 0) {
      <div class="archives-section">
        <span class="section-title">{{ 'FILE_GROUPS.ARCHIVES_LABEL' | translate }}</span>

        @if (!archives.length) {
        <p class="empty-hint">{{ 'FILE_GROUPS.NO_ARCHIVES_HINT' | translate }}</p>
        }

        <div class="archives-list">
          @for (archive of archives; track archive.id) {
          <div class="archive-row">
            <div class="archive-name" [title]="archive.name">
              <fa-icon [icon]="faFile"></fa-icon>
              <span>{{ archive.name }}</span>
            </div>
            <div class="archive-group-toggles">
              @for (group of groups; track group.id) {
              <button type="button" class="group-toggle-chip" [class.active]="isArchiveInGroup(group, archive.id)"
                [style.background-color]="isArchiveInGroup(group, archive.id) ? group.bg_color : 'transparent'"
                [style.color]="isArchiveInGroup(group, archive.id) ? group.text_color : 'var(--text-secondary)'"
                [style.border-color]="group.bg_color" (click)="toggleArchiveInGroup(group, archive.id)">
                {{ group.name }}
              </button>
              }
            </div>
          </div>
          }
        </div>
      </div>
      }

    </div>

    <div class="modal-footer">
      <app-button [text]="'BUTTON.CLOSE' | translate" variant="primary" (clicked)="onClose()">
      </app-button>
    </div>
  </div>
</div>
}

<app-modal-delete-confirm [show]="showDeleteConfirm" [configKey]="groupToDelete?.name || ''"
  [configType]="'FILE_GROUPS.GROUP' | translate" [impactItems]="deleteGroupImpactItems"
  (close)="onDeleteConfirmClose()" (confirm)="onDeleteConfirmConfirm()">
</app-modal-delete-confirm>
